export const REQUIRED_FIELDS = {
  ADD_RECIPIENT: ['emails'],
  SET_THRESHOLD: ['lowBalance'],
};

export const MODAL_TYPES = {
  ADD_RECIPIENT: 'ADD_RECIPIENT',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};
